// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__37N7u","fileBtn":"File_fileBtn__2R0w2","closeBtn":"File_closeBtn__3VRie","fileSelected":"File_fileSelected__1pWWn","disabled":"File_disabled__1ozDm"};